import type { UserAuthSlice, UserAuthState, ViewerSliceCreator } from "./types";

export const userAuthInitialState: UserAuthState = {
  user: null,
  userLoading: false,
  userError: null,
};

export const createUserAuthSlice: ViewerSliceCreator<UserAuthSlice> = (set) => ({
  ...userAuthInitialState,

  setUser: (user) =>
    set((state) => {
      state.user = user;
    }),

  setUserLoading: (loading) =>
    set((state) => {
      state.userLoading = loading;
    }),

  setUserError: (error) =>
    set((state) => {
      state.userError = error;
    }),
});
